const d3 = require('d3')

const moment = require('moment');

const momentSort = ({date:date1},{date:date2})=>moment(date1).diff(moment(date2),'seconds')

function wrap(text, width) {
  text.each(function () {
    var text = d3.select(this),
      words = text.text().split(/\s+/),
      word,
      line = [],
      lineNumber = 0,
      lineHeight = 1.2, // ems
      y = text.attr('y'),
      dy = parseFloat(text.attr('dy')),
      tspan = text
        .text(null)
        .append('tspan')
        .attr('x', 0)
        .attr('y', y)
        .attr('dy', dy + 'em');
    while ((word = words.pop())) {
      line.push(word);
      line.pop();
      tspan.text(line.join(' '));
      line = [word];
      tspan = text
        .append('tspan')
        .attr('x', 0)
        .attr('y', y)
        .attr('dy', ++lineNumber * lineHeight + dy + 'em')
        .text(word);
    }
  });
}

module.exports={momentSort,wrap}
